import { LevelRewardInputType } from '../../../../../__gqltypes__';

export type LoyaltyCampaignConfigRow = {
  id: string;
  amount: number;
  updatedAt?: string;
};

export type LoyaltyCampaignCardType = 'ONE_TIME' | 'INFINITE';
export type LoyaltyCampaignClaimMode = LoyaltyCampaignCardType | 'CUSTOM';
export type LoyaltyCampaignCardKind = 'BUNDLE' | 'ITEM';
export type LoyaltyCampaignItemCategory = 'COINS' | 'DIAMONDS' | 'BOOSTS' | 'FRAGMENTS' | 'VANITY' | 'OTHER';
export type VanityItemType = 'VINYL' | 'FRAME' | 'STICKER';
export type ConfigModalMode = 'create' | 'groupAdd' | 'groupEdit';

export type SavedRewardRow = {
  __typename?: string;
  amount?: number | null;
  id?: string | null;
  name?: string | null;
  boostType?: string | null;
  unlimitedBoostType?: string | null;
  category?: { id: string } | null;
  contentPack?: { id: string } | null;
};

export type LoyaltyCampaignCardRow = {
  id: string;
  kind?: LoyaltyCampaignCardKind;
  name: string;
  groupId?: string | null;
  groupName?: string | null;
  groupDisplayOrder?: number | null;
  groupStartDate?: string | null;
  groupEndDate?: string | null;
  subgroupId?: string | null;
  subgroupName?: string | null;
  subgroupDisplayOrder?: number | null;
  subgroupStartDate?: string | null;
  subgroupEndDate?: string | null;
  itemDisplayOrder?: number | null;
  displayOrder?: number;
  cost: number;
  itemBonusLoyaltyPoints?: number | null;
  claimType?: LoyaltyCampaignCardType;
  maxClaims?: number | null;
  created?: string;
  rewards?: SavedRewardRow[];
};

export type RewardFormInput = {
  type: string;
  amount: number;
  itemId: string;
  itemName?: string;
};

export type LoyaltyCampaignSkuPriceRow = {
  sku?: string | null;
  priceUsd?: number | null;
};

export type LoyaltyCampaignOfferOptionRow = {
  id: string;
  label: string;
  priceUsd?: number | null;
  skus: string[];
};

export type LoyaltyCampaignCardSectionId =
  | 'bundle'
  | 'item-coins'
  | 'item-diamonds'
  | 'item-boosts'
  | 'item-fragments'
  | 'item-vanity'
  | 'item-other';

export const LOYALTY_CAMPAIGN_ALLOWED_REWARD_TYPES: LevelRewardInputType[] = [
  LevelRewardInputType.CURRENCY_COIN,
  LevelRewardInputType.CURRENCY_DIAMOND,
  LevelRewardInputType.CURRENCY_TOURNAMENT_TICKET,
  LevelRewardInputType.CURRENCY_BOOST,
  LevelRewardInputType.CURRENCY_CATEGORY_FRAGMENT,
  LevelRewardInputType.CONTENT_PACK_REWARD,
  LevelRewardInputType.CURRENCY_SPECIAL_EVENT,
  LevelRewardInputType.CURRENCY_META_FRAGMENT_BRONZE,
  LevelRewardInputType.CURRENCY_META_FRAGMENT_SILVER,
  LevelRewardInputType.CURRENCY_META_FRAGMENT_GOLD,
  LevelRewardInputType.CURRENCY_SHARD_BRONZE,
  LevelRewardInputType.CURRENCY_SHARD_SILVER,
  LevelRewardInputType.CURRENCY_SHARD_GOLD,
  LevelRewardInputType.CURRENCY_ACCOLADE,
  LevelRewardInputType.CURRENCY_LOYALTY_POINT,
  LevelRewardInputType.STICKER,
  LevelRewardInputType.PROFILE_FRAME,
  LevelRewardInputType.APP_SKIN,
  LevelRewardInputType.BADGE,
  LevelRewardInputType.POSTER,
  LevelRewardInputType.EMOJI,
  LevelRewardInputType.EMOJI_PACK,
  LevelRewardInputType.MONTHLY_BUFF,
  LevelRewardInputType.CURRENCY_FREE_SPIN,
];

export const LOYALTY_CAMPAIGN_ITEM_CATEGORY_LABELS: Record<LoyaltyCampaignItemCategory, string> = {
  COINS: 'Coins',
  DIAMONDS: 'Diamonds',
  BOOSTS: 'Boosts',
  FRAGMENTS: 'Fragments',
  VANITY: 'Vanity Items',
  OTHER: 'Other Items',
};

export const LOYALTY_CAMPAIGN_ITEM_CATEGORY_ADD_LABELS: Record<LoyaltyCampaignItemCategory, string> = {
  COINS: 'Add Coins',
  DIAMONDS: 'Add Diamonds',
  BOOSTS: 'Add Boosts',
  FRAGMENTS: 'Add Fragments',
  VANITY: 'Add Vanity Item',
  OTHER: 'Add Other Item',
};

export const LOYALTY_CAMPAIGN_ITEM_CATEGORY_DESCRIPTIONS: Record<LoyaltyCampaignItemCategory, string> = {
  COINS: 'Use for coin packs like 1,000 or 6,500 coins.',
  DIAMONDS: 'Use for diamond packs or promo diamond offers.',
  BOOSTS: 'Use for gameplay boosts like Remove 2, Team Spirit, or Revive.',
  FRAGMENTS: 'Use for category fragment rewards.',
  VANITY: 'Use for cosmetics like sticker, profile frame, app skin, badge, poster, emoji, and emoji pack.',
  OTHER: 'Fallback group for item types outside the current shop sections.',
};

export const VANITY_ITEM_LABELS: Record<VanityItemType, string> = {
  VINYL: 'Vinyl',
  FRAME: 'Frame',
  STICKER: 'Sticker',
};

export const VANITY_ITEM_REWARD_TYPES: Record<VanityItemType, LevelRewardInputType> = {
  VINYL: LevelRewardInputType.APP_SKIN,
  FRAME: LevelRewardInputType.PROFILE_FRAME,
  STICKER: LevelRewardInputType.STICKER,
};
